import * as React from "react";
import clsx from "clsx";
import styles from "./EmptyState.module.css";

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={clsx(styles.root, className)}>
      {icon && (
        <div className={styles.icon}>
          {icon}
        </div>
      )}
      <h4 className={styles.title}>{title}</h4>
      {description && (
        <p className={styles.description}>{description}</p>
      )}
      {action && action}
    </div>
  );
}
